import { Link } from 'react-router-dom';

import paths from '~/lib/paths';

import styles from './styles';

function EmptyPlaceholder({ classes, integrate }) {
  return (
    <div className={classes.root}>
      <p className={classes.heading}>Nothing to show</p>

      {integrate && (
        <p>
          You may need to integrate Clearbit JS or Segment in to your app to
          begin the data flow.
          <br />
          Navigate to our{' '}
          <Link to={paths.configurations()}>configuration page</Link> to get
          started.
        </p>
      )}
    </div>
  );
}

EmptyPlaceholder.propTypes = {
  classes: PropTypes.object.isRequired,
  integrate: PropTypes.bool,
};

export default withStyles(styles)(EmptyPlaceholder);
